import { createFileRoute } from "@tanstack/react-router";
import CareFirstInsurance, { config } from "@/pages/CareFirstInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/carefirst-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "CareFirst TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "CareFirst BlueCross BlueShield coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "CareFirst TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "CareFirst BlueCross BlueShield coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/carefirst-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/carefirst-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <CareFirstInsurance />;
}
